/**
 * `avatar.lipSync` (Companion SDK 2.12.0) → the SDK's module-level lip-sync
 * flags. See CompanionAvatarThemeConfig.lipSync for the option contract and
 * core/utils/progressiveLipSync.ts for what each flag changes.
 */

import {
  setGreetingModelReadyGateEnabled,
  setProgressiveLipSyncEnabled
} from '../core/utils/progressiveLipSync';
import type { CompanionAvatarThemeConfig } from './types';

export type CompanionLipSyncConfig = NonNullable<CompanionAvatarThemeConfig['lipSync']>;

export interface ResolvedCompanionLipSyncConfig {
  progressive: boolean;
  greetingWaitsForModel: boolean;
}

/** Both default ON; only an explicit `false` turns a behaviour off. */
export function resolveCompanionLipSyncConfig(
  input: CompanionLipSyncConfig | null | undefined
): ResolvedCompanionLipSyncConfig {
  return {
    progressive: input?.progressive !== false,
    greetingWaitsForModel: input?.greetingWaitsForModel !== false
  };
}

export function applyCompanionLipSyncConfig(input: CompanionLipSyncConfig | null | undefined): ResolvedCompanionLipSyncConfig {
  const resolved = resolveCompanionLipSyncConfig(input);
  setProgressiveLipSyncEnabled(resolved.progressive);
  setGreetingModelReadyGateEnabled(resolved.greetingWaitsForModel);
  return resolved;
}
